/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.app.permissions.hublets.rpc.AppPermissionsHubletsPublicRpc
 */

export const getAppPermissionTranslationsRpc = {
  serviceName: 'com.hubspot.app.permissions.hublets.rpc.AppPermissionsHubletsPublicRpc',
  rpcName: 'getAppPermissionTranslations',
  auth: 'external',
  fingerprint: '7do5wyaI2vhjOM8JpLEURAxAsniWr2JX',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};